import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { RCEHelpersPropTypes, withRCEHelpers } from './components/rce-helpers-context/index.js';
import { s as styleInject } from './style-inject.es-746bb8ed.js';
import VoterAvatar from './components/voted-users/VoterAvatar.js';
import { RemoveIcon } from './assets/icons/RemoveIcon.js';
import { LoaderIcon } from './assets/icons/LoaderIcon.js';

var css_248z = ".EW5C9{display:flex;font-size:14px}[dir] .EW5C9{margin:10px 0 0}.EW5C9.z0Dm1{display:none}._0xtBf{display:inline-block;list-style:none}[dir] ._0xtBf{margin:0 10px;padding:0}._7tZt6,.tUpx4{display:inline-block;height:20px;overflow:hidden;width:20px}[dir] ._7tZt6,[dir] .tUpx4{border-radius:50%}[dir=ltr] ._7tZt6:not(:first-child),[dir=ltr] .tUpx4:not(:first-child){margin-left:-5px}[dir=rtl] ._7tZt6:not(:first-child),[dir=rtl] .tUpx4:not(:first-child){margin-right:-5px}.YzoPL{color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;height:420px;width:450px}[dir] .YzoPL{background:#fff}@supports not (contain:inline-size){@media only screen and (max-width:640px){.YzoPL{height:100%;width:100%}}}@container (width < 640px){.YzoPL{height:100%;width:100%}}.j-NQS{height:100%}._3Uiga,.j-NQS{display:flex;flex-direction:column}._3Uiga{align-items:center;bottom:0;justify-content:center;position:fixed;top:0;z-index:8}[dir] ._3Uiga{background-color:rgba(0,0,0,.6);cursor:auto}[dir=ltr] ._3Uiga,[dir=rtl] ._3Uiga{left:0;right:0}.GZBu-{align-items:center;display:flex;flex-direction:row}[dir] .GZBu-{border-bottom:1px solid rgba(0,0,0,.2);padding:20px 0}._7tZt6{height:36px;width:36px}.kKvQF{font-size:16px}[dir=ltr] .kKvQF{margin-left:10px}[dir=rtl] .kKvQF{margin-right:10px}.fbZF-{align-items:center;display:flex;justify-content:space-between}[dir] .fbZF-{border-bottom:1px solid rgba(0,0,0,.2);padding:10px 20px}[dir] .Zin6D,[dir] .oBWFV{cursor:pointer}[dir=ltr] .Zin6D{margin-right:-5px}[dir=rtl] .Zin6D{margin-left:-5px}.fbZF- .YwpBU{font-size:16px;font-weight:900}[dir] .fbZF- .YwpBU{margin:0}.VrWJn{flex:1;overflow:auto}[dir] .VrWJn{padding:0 20px}._3aMPK{list-style:none}[dir] ._3aMPK{margin:0;padding:0}[dir] .U8YlW{padding:10px 20px;text-align:center}.ej5k8{font-size:16px}[dir] .ej5k8{margin:0;padding:20px}.wGO8n{animation-duration:1.5s;animation-iteration-count:infinite;animation-name:cIPKb;animation-timing-function:linear}@keyframes cIPKb{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
var styles = {"container":"EW5C9","webview":"z0Dm1","avatar_list":"_0xtBf","avatar":"tUpx4","user_avatar":"_7tZt6","modal":"YzoPL","voted_users_modal":"j-NQS","overlay":"_3Uiga","user_card":"GZBu-","user_name":"kKvQF","voted_users_modal_header":"fbZF-","cta":"oBWFV","close_icon":"Zin6D","title":"YwpBU","member_list_container":"VrWJn","member_list":"_3aMPK","loader":"U8YlW","anonymous_counter":"ej5k8","spinner":"wGO8n","spin":"cIPKb"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VotedUsersModalComponent extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      members: [],
      moreItems: true,
      cursor: void 0
    });
    __publicField(this, "fetchVoters", async () => {
      const { getSiteMember } = this.props;
      const { members, cursor } = this.state;
      try {
        const { voters, moreItems } = await this.props.fetchVoters({ cursor, limit: 10 });
        this.setState({
          members: members.concat(voters.map((member) => member.memberId).map(getSiteMember)),
          cursor: voters[voters.length - 1].memberId,
          moreItems
        });
      } catch (error) {
      }
    });
  }
  render() {
    const { t, option, onRequestClose } = this.props;
    const { members, moreItems } = this.state;
    return /* @__PURE__ */ React.createElement("div", { className: styles.voted_users_modal }, /* @__PURE__ */ React.createElement("div", { className: styles.voted_users_modal_header }, /* @__PURE__ */ React.createElement("p", { className: styles.title }, t("Poll_Viewer_VoteCount_Modal_Voters_Header", {
      count: option.count,
      number: option.count
    })), /* @__PURE__ */ React.createElement(RemoveIcon, { onClick: onRequestClose, className: styles.close_icon })), /* @__PURE__ */ React.createElement(
      InfiniteScroll,
      {
        className: styles.member_list_container,
        initialLoad: true,
        hasMore: moreItems,
        loadMore: this.fetchVoters,
        loader: /* @__PURE__ */ React.createElement("div", { className: styles.loader }, /* @__PURE__ */ React.createElement(LoaderIcon, { width: 24, height: 24, className: styles.spinner }))
      },
      /* @__PURE__ */ React.createElement("ul", { className: styles.member_list }, members.map((member) => {
        var _a;
        return member ? /* @__PURE__ */ React.createElement("li", { key: member.siteMemberId }, /* @__PURE__ */ React.createElement("div", { className: styles.user_card }, /* @__PURE__ */ React.createElement(
          VoterAvatar,
          {
            className: styles.user_avatar,
            memberInfo: member,
            src: member.imageUrl,
            size: {
              width: 36,
              height: 36
            }
          }
        ), /* @__PURE__ */ React.createElement("span", { className: styles.user_name }, ((_a = member.name) == null ? void 0 : _a.nick) || t("Poll_Viewer_VoteCount_Modal_Voters_Private_Voter")))) : null;
      }))
    ), option.anonymousCount ? /* @__PURE__ */ React.createElement("p", { className: styles.anonymous_counter }, t("Poll_Viewer_VoteCount_Modal_Voters_Anonymous", {
      anonNumber: option.anonymousCount
    })) : null);
  }
}
__publicField(VotedUsersModalComponent, "propTypes", __spreadValues({}, RCEHelpersPropTypes));
const VotedUsersModal = withRCEHelpers(VotedUsersModalComponent);

export { VotedUsersModal as V, VotedUsersModalComponent as a, styles as s };
//# sourceMappingURL=VotedUsersModal-e240cd2e.js.map
